import { defineStore } from 'pinia'

import { apiClientDB } from '@/config_sessions'

export const useAPITypeStore = defineStore({
    id: 'apitype',

    state: () => ({
        apitypes: [],
        loading: false,
        error: null
    }),

    getters: {

    },
    
    actions: {
        async fetchAPITypes() {
            this.apitypes = []
            this.loading = true
            try {
                const response = await apiClientDB.get(`/apitypes/`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    }
                })
                this.apitypes = response.data.apitypes
            }
            catch (error) {
                this.error = error
            }
            finally {
                this.loading = false
            }
        }
    }
})